import { render, staticRenderFns } from "./MembershipList.vue?vue&type=template&id=5d39a0fb"
import script from "./MembershipList.vue?vue&type=script&lang=js"
export * from "./MembershipList.vue?vue&type=script&lang=js"
import style0 from "./MembershipList.vue?vue&type=style&index=0&id=5d39a0fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports